/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_SaveInputs */

const vi_irrigation_schedule_save = /** @type {(inputs: Irrigation_Schedule_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu lịch`)
};

/**

* @param {Irrigation_Schedule_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_save = /** @type {((inputs?: Irrigation_Schedule_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_save(inputs)
});